module.exports = __webpack_public_path__ + "img/ms_my.ec8cd092.png";